import script from "./ServerIssue.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServerIssue.vue?vue&type=script&lang=ts&setup=true"

import "./ServerIssue.vue?vue&type=style&index=0&id=284a7f90&lang=scss"

export default script